<script setup lang="ts">
import { computed, watch } from 'vue'
import { ISensorFormData } from '@/interfaces/components/createSensor/create-sensor.ts'
import InputGroup from '@/components/Auths/InputGroup.vue'

const props = defineProps<{
  modelValue: ISensorFormData
}>()

const emit = defineEmits(['update:modelValue', 'validate'])

const formData = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const isValid = computed(() => {
  const hasName = formData.value.sensor_name && formData.value.sensor_name.trim().length > 0
  const hasMac = formData.value.mac_address && formData.value.mac_address.trim().length > 0
  const hasSubId = formData.value.subid && formData.value.subid.trim().length > 0
  
  return hasName && hasMac && hasSubId
})

watch(isValid, (valid) => {
  emit('validate', valid)
}, { immediate: true })

</script>

<template>
  <div class="max-w-xl mx-auto w-full animate-fadeIn">
    
    <div class="text-center mb-8">
      <h2 class="text-2xl font-bold text-slate-900">Identificação</h2>
      <p class="text-body text-slate-500 mt-1">
        Informe os dados de identificação do dispositivo.
      </p>
    </div>

    <div class="flex flex-col gap-5">
      <InputGroup
        label="Nome do Sensor"
        name="sensor_name"
        type="text"
        placeholder="Ex: EXTRUSORA 01"
        v-model="formData.sensor_name"
      />
      <InputGroup
        label="SubID"
        name="subid"
        type="text"
        placeholder="Ex: BLUE222/pub"
        v-model="formData.subid"
      />
      <InputGroup
        label="Endereço MAC"
        name="mac_address"
        type="text"
        placeholder="Ex: AACA002A0ZC1"
        v-model="formData.mac_address"
      />
    </div>
  </div>
</template>

<style scoped>
.animate-fadeIn {
  animation: fadeIn 0.4s ease-out;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>